import React from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import _ from 'lodash';

import helpers from '../lib/helpers';

const logos = helpers.importAll(require.context('../assets/news', false, /\.png$/));

export default class News extends React.Component {
  renderNews(news, i) {
    const newsImage = `${news.image}.png`;
    return (
      <Col key={news.image} className="logo-card-wrap" xs={12} md={(i === 0) ? 12 : 6} key={news.image}>
        <div className="logo-card">
          <a href={news.website} className="logo-img-wrap" target="_blank">
            <div style={{ backgroundImage: `url(${logos[newsImage]})` }} className="logo-img" />
          </a>
        </div>
      </Col>
    );
  }

  render() {
    return (
      <Grid fluid>
        <Row className="logo-container">
          {_.map(APP_CONFIG.news, (news, i) => this.renderNews(news, i))}
        </Row>
      </Grid>
    );
  }
}
